import React, { useEffect, useState } from "react";
import "./Header.css";
import { HashLink } from 'react-router-hash-link';


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen((v) => !v);
  const closeMenu = () => setMenuOpen(false);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => document.body.classList.remove("no-scroll");
  }, [menuOpen]);

  return (
    <>
      <header className="site-header">
        {/* Logo */}
       <div className="logo">
  <a href="/">
    <img 
      src="/CPH.png" 
      alt="Horizon" 
      className="logo-img"
    />
  </a>
</div>


        {/* Desktop Nav */}
        <nav className="main-nav" aria-label="Primary">
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/vacancies">Vacancies</a></li>
            <li><HashLink smooth to="/about#contact" className="btn-contact">
  Contact
</HashLink></li>
          </ul>
        </nav>

        {/* Desktop Pills */}
        <div className="header-icons">
          <button className="pill search" type="button">🔍 <span>Search</span></button>
          <button className="pill accessibility" type="button">🧑‍🦯 <span>Accessibility</span></button>
        </div>

        {/* Mobile Hamburger (only visible on mobile via CSS) */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="mobile-drawer"
          type="button"
        >
          ☰
        </button>
      </header>

      {/* Mobile Drawer (visible only on mobile via CSS) */}
      <aside
        id="mobile-drawer"
        className={`mobile-menu ${menuOpen ? "open" : ""}`}
        aria-hidden={!menuOpen}
      >
        <ul>
          <li><a href="/about" onClick={closeMenu}>About</a></li>
          <li><a href="/vacancies" onClick={closeMenu}>Vacancies</a></li>
          <li><HashLink smooth to="/about#contact" className="btn-contact">
  Contact
</HashLink></li>
        </ul>
      </aside>

      {/* Overlay (mobile only via CSS) */}
      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMenu}
        aria-hidden="true"
      />
    </>
  );
};

export default Header;
